import React from 'react';
import '../../../dist/assets/stylesheets/css/recordPatient.css';
import GreyButton from '../GreyButton';

function PatientSelection(props) {
    const dataUnset = props.data == null;
    const rows = Array.isArray(props.data) ? props.data : [];

    return (
        <div className="table-container patient-selection">
            <table>
                <thead>
                    <tr>
                        <th>Patient</th>
                        <th>Email</th>
                        <th>Condition</th>
                    </tr>
                    <tr>
                        <th colSpan="3">
                            <GreyButton title="Add new patient" width="100%" onClick={props.addNewPatient} />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {dataUnset ? (
                        <tr>
                            <td colSpan={3} style={{ textAlign: 'center', color: '#666', padding: '16px' }}>
                                Loading patients…
                            </td>
                        </tr>
                    ) : rows.length === 0 ? (
                        <tr>
                            <td colSpan={3} style={{ textAlign: 'center', color: '#666', padding: '16px' }}>
                                No patients found.
                            </td>
                        </tr>
                    ) : (
                        rows.map((el) => (
                            <tr
                                key={el.patient_id}
                                className={props.selected == el.patient_id ? 'selected' : ''}
                                onClick={() => props.selectPatient(el.patient_id)}
                            >
                                <td>{el.patient_name}</td>
                                <td>{el.patient_email}</td>
                                <td>{el.patient_condition}</td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default PatientSelection;
